// All user-facing strings, keyed by language.
// Markdown page content lives in src/data/{about,recruiters}.{en,pl}.md

export const LANGUAGES = ['en', 'pl'];

export const RESUME_URLS = {
  en: 'https://docs.google.com/document/d/18WXYSDLu_OhpTkbqcGsObTjcmBSQTxjixlQS6uuEDuk/edit?tab=t.0',
  pl: 'https://docs.google.com/document/d/1ZFLt71sBktMuJOjpuoZ1QXBIufKU-j11zEjp2XItxUA/edit?tab=t.0',
};

const strings = {
  en: {
    nav: {
      about: 'About',
      recruiters: 'Recruiters',
      resume: 'Resume',
    },
    switchTo: 'Polski',
    switchLabel: 'Przełącz na język polski',
    about: {
      title: 'About',
      heading: 'About Me',
      description: 'Learn about Sara Buczna',
    },
    recruiters: {
      title: 'For Recruiters',
      heading: 'For Recruiters',
      description: 'Information for recruiters interested in working with Sara Buczna',
    },
    resumeButton: 'Resume',
    redirecting: 'Redirecting to Resume...',
    redirectFallback: 'If you are not redirected automatically,',
    clickHere: 'click here',
    notFound: {
      title: '404 Not Found',
      heading: 'Page Not Found',
      back: 'Return',
      home: 'home',
    },
    sidebar: {
      about: 'About',
    },
    stats: [
      { key: 'location', label: 'Current city', value: 'Warsaw, Poland' },
      { key: 'languages', label: 'Languages', value: 'Polish, English, Spanish' },
    ],
    description: "Sara Buczna's personal website. Dietitian in Warsaw.",
  },
  pl: {
    nav: {
      about: 'O mnie',
      recruiters: 'Dla rekruterów',
      resume: 'CV',
    },
    switchTo: 'English',
    switchLabel: 'Switch to English',
    about: {
      title: 'O mnie',
      heading: 'O mnie',
      description: 'Poznaj Sarę Buczną',
    },
    recruiters: {
      title: 'Dla rekruterów',
      heading: 'Dla rekruterów',
      description: 'Informacje dla rekruterów zainteresowanych współpracą z Sarą Buczną',
    },
    resumeButton: 'CV',
    redirecting: 'Przekierowanie do CV...',
    redirectFallback: 'Jeśli przekierowanie nie nastąpi automatycznie,',
    clickHere: 'kliknij tutaj',
    notFound: {
      title: '404 Nie znaleziono',
      heading: 'Nie znaleziono strony',
      back: 'Wróć na',
      home: 'stronę główną',
    },
    sidebar: {
      about: 'O mnie',
    },
    stats: [
      { key: 'location', label: 'Miasto', value: 'Warszawa, Polska' },
      { key: 'languages', label: 'Języki', value: 'polski, angielski, hiszpański' },
    ],
    description: 'Strona Sary Bucznej. Dietetyczka w Warszawie.',
  },
};

export default strings;
